export const subComponents = (translations) => [
    { name: translations["users"] || "Users", path: '/users', permissions: ['user'] },
    { name: translations["roles"] || "Roles", path: '/roles', permissions: ['role_list'] },
    { name: translations["account_view"] || "Account", path: '/account-details', permissions: ['account_view'] },
]
